import { render, staticRenderFns } from "./CardCollapse.vue?vue&type=template&id=2c280b8c&"
import script from "./CardCollapse.vue?vue&type=script&lang=js&"
export * from "./CardCollapse.vue?vue&type=script&lang=js&"
import style0 from "./CardCollapse.vue?vue&type=style&index=0&id=2c280b8c&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports